/**
 * supabaseClient.ts — client SDK init. Values come from web/.env (see
 * .env.example). The anon key is safe to expose client-side — it identifies
 * the project and carries no elevated privilege by itself; every table has
 * deny-all RLS (see ../../DATA_MODEL.md), so a direct client read/write with
 * just the anon key is refused regardless. All real access goes through the
 * `api` Edge Function using the service_role key server-side.
 */
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL ?? '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY ?? '';

if (!supabaseUrl || !supabaseAnonKey) {
  // eslint-disable-next-line no-console
  console.warn('Supabase config is not set — copy web/.env.example to web/.env and fill in your project URL/anon key.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
